import { useUserContext } from "@/components/user-context";

import { LoggedOutJiraFree } from "./free";
import { LoggedOutJiraPremium } from "./premium";
import { LoggedOutJiraStandard } from "./standard";

export const LoggedOutJira = () => {
    const { edition } = useUserContext();

    if (edition === "premium") {
        return <LoggedOutJiraPremium />;
    }

    if (edition === "standard") {
        return <LoggedOutJiraStandard />;
    }

    return <LoggedOutJiraFree />;
};
